import React from 'react';
import styles from './AbstractDetailsForm.module.scss';
import {Form, Formik} from 'formik';
import {Grid} from '@material-ui/core';
import StepButtons from './components/stepButtons';
import EditorSection from '../editorSection';
import fill from 'fill-range';
import objectArrayTools from 'object-arrarify';
import GuaranteePoints
  from 'gui/pages/mainRouter/pages/ad/components/commons/preparedAdStructure/components/purchaseForm/components/guarantees/components/guaranteePoints';
import PaymentOptions
  from 'gui/pages/mainRouter/pages/ad/components/commons/preparedAdStructure/components/purchaseForm/components/guarantees/components/paymentOptions';
import { ValidationSchemaProvider } from '../validateSchemaProvider/ValidationSchemaProvider ';

interface IAbstractProductDetailsFormProps {
  className?: string;
  onSubmit: (formValues, options?: any) => Promise<any>;

  yupSchemaObject?: any;
  initialValues?: any;
  setSubmitRef?: any;
  commonFormComponents?: any;
  formComponents?: any;
  underFormComponents?: any;
  activeStep?: number;

  steps?: string[],
  loading?: boolean;
}

const LoadingSections = () => fill(0, 2)
  .map(index => <EditorSection
    key={index}
    loading={true}/>)

const AbstractDetailsForm = (props: IAbstractProductDetailsFormProps) => {
  return (
    <Formik
      initialValues={props.initialValues}
      initialTouched={objectArrayTools(props.initialValues).map(() => false).toNormalObject()}
      validationSchema={props.yupSchemaObject}
      onSubmit={(values, options) => {
        return props
          .onSubmit(values, options);
      }}
      enableReinitialize={true}
    >
      {(form) => (
        <Form translate={null} className={`${styles.form} ${props.className}`.trim()}>
          <ValidationSchemaProvider schema={props.yupSchemaObject}>
          <Grid className={`${styles.AbstractDetailsForm} detailsForm`} container spacing={2}>
            {(props.loading) ?
              <LoadingSections/>
              :
              (typeof props.formComponents === 'function' ? props.formComponents(form) : null)}
          </Grid>
          {(props.loading) ?
            <LoadingSections/>
            :
            (typeof props.underFormComponents === 'function' ? props.underFormComponents(form) : null)}
          <Grid item xs={12} className={styles.buttonsContainer}>
            <GuaranteePoints className={styles.guaranteePoints}/>
            <PaymentOptions className={styles.paymentOptions}/>
            <StepButtons
              steps={props.steps}
              submitForm={form.submitForm}
              isSubmitting={form.isSubmitting}
              setFieldValue={form.setFieldValue}
              setSubmitRef={props.setSubmitRef}
              activeStep={props.activeStep}
              loading={props.loading}
            />
          </Grid>
          {props.commonFormComponents(form)}
          </ValidationSchemaProvider>
        </Form>
      )}
    </Formik>
  );
}

AbstractDetailsForm.defaultProps = {
  className: '',
  initialValues: {},
  onSubmit: (formValues) => new Promise((resolve) => {
    
    setTimeout(resolve, 1000);
  }),
  setSubmitRef: () => {
  },
  commonFormComponents: () => null,
  formComponents: null,
};

export default React.memo(AbstractDetailsForm);
